import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
export default function AuthCallback() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(match[1]);

        (async () => {
            try {
                await api.post("/auth/session", { session_id: sessionId });
                await refresh();
                window.history.replaceState(null, "", "/biblioteca");
                navigate("/biblioteca", { replace: true });
                toast.success(t("auth.toast_google_ok"));
            } catch {
                toast.error(t("auth.toast_google_fail"));
                navigate("/acceder", { replace: true });
            }
        })();
    }, [navigate, refresh, t]);

    return (
        <main className="min-h-[calc(100vh-73px)] flex items-center justify-center">
            <p className="font-display text-2xl text-[var(--ink)] animate-slow-pulse italic">
                {t("auth.callback_loading")}
            </p>
        </main>
    );
}
